import React, { InputHTMLAttributes, useState } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  id,
  containerClassName = '',
  type,
  value,
  ...rest
}) => {
  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);
  const hasValue = isPassword && typeof value === 'string' ? value.length > 0 : false;

  return (
    <div className={`${styles['form-group']} ${containerClassName}`}>
      {label && (
        <label htmlFor={id} className={styles['form-label']}>
          {label}
        </label>
      )}
      <div className={styles['input-wrapper']}>
        <input
          id={id}
          className={`${styles['form-input']} ${isPassword ? styles['form-input-password'] : ''}`}
          autoComplete="off"
          type={isPassword && showPassword ? 'text' : type}
          value={value}
          {...rest}
        />
        {isPassword && hasValue && (
          <button
            type="button"
            className={styles['password-toggle']}
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={-1}
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
              {showPassword ? 'visibility_off' : 'visibility'}
            </span>
          </button>
        )}
      </div>
      {error && <span className={styles['error-text']}>{error}</span>}
    </div>
  );
};

export default Input;
